window.hydrationCallbacks = {};
let observer = {};

const intersectionObserverCallback = (entries, cbObserver) => {
  entries.forEach(scriptElem => {
    if (scriptElem.intersectionRatio > 0) {
      const compId = scriptElem.target && scriptElem.target.getAttribute('data-compid');
      if (typeof window.hydrationCallbacks[compId] === 'function') {
        window.hydrationCallbacks[compId]();
        delete window.hydrationCallbacks[compId];
      }
      cbObserver.unobserve(scriptElem.target);
    }
  });
};

const attachHydrationIntersectionObserver = () => {
  const options = {
    rootMargin: '50px',
  };

  observer = new IntersectionObserver(intersectionObserverCallback, options);
};

window.startObserve = element => {
  observer?.observe?.(element);
};
export default attachHydrationIntersectionObserver;
